import React, { useState } from "react";
import { Link } from "react-router-dom";

export default function BugReportButton() {
  const [hovered, setHovered] = useState(false);

  return (
    <>
      <Link
        to="/signaler-un-probleme"
        className="brb-fab"
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        aria-label="Signaler un problème"
      >
        {/* Pulse rings */}
        <span className="brb-ring brb-ring-1" />
        <span className="brb-ring brb-ring-2" />

        {/* Icon */}
        <span className="brb-icon-wrap">
          <svg
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="brb-icon"
          >
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="8" x2="12" y2="12" />
            <line x1="12" y1="16" x2="12.01" y2="16" />
          </svg>
        </span>

        {/* Tooltip label */}
        <span className={`brb-label ${hovered ? "brb-label-visible" : ""}`}>
          Signaler un problème
        </span>
      </Link>

      <style>{`
        .brb-fab {
          position: fixed;
          bottom: 28px;
          left: 28px;
          z-index: 9999;
          display: flex;
          align-items: center;
          gap: 10px;
          text-decoration: none;
          cursor: pointer;
        }

        /* The circular button */
        .brb-icon-wrap {
          position: relative;
          width: 52px;
          height: 52px;
          border-radius: 50%;
          background: linear-gradient(145deg, #1e293b, #0f172a);
          color: #FFC300;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.35), inset 0 1px 0 rgba(255,255,255,0.07);
          border: 2px solid rgba(255, 195, 0, 0.35);
          transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1),
                      box-shadow 0.3s ease,
                      border-color 0.3s ease;
          animation: brb-float 4s ease-in-out infinite;
          flex-shrink: 0;
        }

        .brb-fab:hover .brb-icon-wrap {
          transform: scale(1.12) translateY(-3px);
          box-shadow: 0 8px 30px rgba(0,0,0,0.45), 0 0 0 6px rgba(255,195,0,0.12);
          border-color: rgba(255, 195, 0, 0.7);
          animation: none;
        }

        /* Icon wiggle on hover */
        .brb-fab:hover .brb-icon {
          animation: brb-shake 0.5s ease-in-out;
        }

        /* Pulse rings */
        .brb-ring {
          position: absolute;
          left: 28px;
          bottom: 28px;
          width: 52px;
          height: 52px;
          border-radius: 50%;
          border: 2px solid rgba(255, 195, 0, 0.5);
          pointer-events: none;
        }

        .brb-ring-1 {
          animation: brb-pulse 2.5s ease-out infinite;
        }

        .brb-ring-2 {
          animation: brb-pulse 2.5s ease-out 1.25s infinite;
        }

        .brb-fab:hover .brb-ring-1,
        .brb-fab:hover .brb-ring-2 {
          animation: none;
          opacity: 0;
        }

        /* Tooltip label */
        .brb-label {
          background: rgba(15, 23, 42, 0.95);
          color: #f1f5f9;
          font-size: 0.8rem;
          font-weight: 600;
          font-family: 'Inter', system-ui, sans-serif;
          padding: 7px 13px;
          border-radius: 8px;
          white-space: nowrap;
          border: 1px solid rgba(255, 195, 0, 0.25);
          backdrop-filter: blur(8px);
          box-shadow: 0 4px 12px rgba(0,0,0,0.3);
          letter-spacing: 0.3px;
          opacity: 0;
          transform: translateX(-6px);
          transition: opacity 0.25s ease, transform 0.25s ease;
          pointer-events: none;
        }

        .brb-label-visible {
          opacity: 1;
          transform: translateX(0px);
        }

        /* Floating animation */
        @keyframes brb-float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-5px); }
        }

        /* Pulse ring animation */
        @keyframes brb-pulse {
          0% {
            transform: scale(1);
            opacity: 0.7;
          }
          100% {
            transform: scale(2.2);
            opacity: 0;
          }
        }

        /* Icon shake on hover */
        @keyframes brb-shake {
          0%  { transform: rotate(0deg); }
          20% { transform: rotate(-12deg); }
          40% { transform: rotate(12deg); }
          60% { transform: rotate(-8deg); }
          80% { transform: rotate(8deg); }
          100%{ transform: rotate(0deg); }
        }
      `}</style>
    </>
  );
}
